<div class="page messages">
    <div class="messages">
        <div class="block"
            [ngClass]="{'error':!type,'warning': type === 'warning','success': type === 'success'}">
            <div [innerHtml]="message"></div>
        </div>
    </div>
</div>